import { CONTENT_SOURCE_UPDATE_STATUS_KO } from '../constants'

import { campaignsBuilderGetArrayOfSourcesByIdList } from 'Api/campaignsBuilderApi'

import {
  contentsSourceApiGetListOfSources,
  contentsSourceApiGetListOfStatus
} from 'Api/contentsSourceApi'

import {
  contentsProvderAddContentsSelection,
  contentsProviderCountContents,
  contentsProviderGetListOfContents
} from 'Api/contentsProviderApi'

import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_ID_LIST,
  storeGet
} from 'mailup-react-helpers'

export async function fetchSources() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const [listSourcesIds, sharedSourcesIds] = await Promise.all([
    campaignsBuilderGetArrayOfSourcesByIdList(idList),
    campaignsBuilderGetArrayOfSourcesByIdList(0)
  ])

  const sources = await contentsSourceApiGetListOfSources({
    filterSourceIds: [
      ...(Array.isArray(listSourcesIds) ? listSourcesIds : []),
      ...(Array.isArray(sharedSourcesIds) ? sharedSourcesIds : [])
    ],
    pageSize: 100,
    pageNumber: 1,
    orderBy: 'UpdateDate',
    orderDescending: true
  })

  return sources.Items.filter(({ IsEnabled }) => IsEnabled).map(
    ({ Id, SourceName, Guid }) => ({
      label: SourceName,
      value: Id,
      guid: Guid
    })
  )
}

export async function fetchSourceLastStatus(sourceId) {
  const { Items } = await contentsSourceApiGetListOfStatus(sourceId, {
    pageNumber: 1,
    pageSize: 1
  })
  return Array.isArray(Items) && Items.length > 0
    ? Items[0].Status
    : CONTENT_SOURCE_UPDATE_STATUS_KO
}

export async function fetchSourceNumberOfContents(sourceId) {
  const result = await contentsProviderCountContents(sourceId)
  return result
}

export async function buildCustomRowsUrl({
  sourceId,
  sourceGuid,
  rows,
  rowContents,
  imgPos,
  imgSpace,
  selectedContents
}) {
  const { Id: idConsole } = storeGet(STORE_KEY_ACCOUNT)

  const cks = Object.entries(selectedContents).map(
    ([_, { contentKey }]) => contentKey
  )

  const cksGuid = cks.length
    ? await contentsProvderAddContentsSelection(sourceId, {
        timeToLive: 86400,
        contentsKey: cks
      })
    : undefined

  const contentsParam = cks.length
    ? `&contents=${encodeURIComponent(cksGuid)}`
    : ''

  return `${process.env.FORM_MULTICHANNEL_URL}/beecustomrows/source/${sourceId}/match/${sourceGuid}/${idConsole}?rows=${rows}&rowContents=${rowContents}&imgPos=${imgPos}&imgSpace=${imgSpace}${contentsParam}`
}

export async function searchContents(idSource, params) {
  const {
    Contents,
    PageNumber,
    PageSize,
    TotalItems
  } = await contentsProviderGetListOfContents(idSource, params)

  return {
    items: Contents.map(
      ({
        ContentKey: contentKey,
        Title: title,
        Summary: summary,
        Hash: hash,
        Image: image
      }) => ({
        contentKey,
        title,
        summary,
        hash,
        image
      })
    ),
    pageNumber: PageNumber,
    pageSize: PageSize,
    totalItems: TotalItems
  }
}
